import { render, staticRenderFns } from "./SalesGrowth.vue?vue&type=template&id=6e6f68e8"
import script from "./SalesGrowth.vue?vue&type=script&lang=ts"
export * from "./SalesGrowth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports